import Axios from "@app/api/axios";

import { REPORTS } from "@utils/constant";

const getReportList = (query = "") => Axios.get(`${REPORTS}${query}`);

export default getReportList;
